<script setup>
    import { computed, onMounted } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import { useWebStore } from "~/store/web";
    import { useScrollToComponent } from "~/composables/useScrollToComponent";


    

    const store = useWebStore();
    const route = useRoute();
    const router = useRouter();
    const { scrollToComponent } = useScrollToComponent();
    //GET THE ID
    const idOfProd = route.params.id
    //=route.path.split('/')[route.path.split('/').length]

    //LANGUAGE SETTING
    route.path.split('/')[1]!==store.chosenLang&&store.setLanguage(route.path.split('/')[1])
    //CURRENT TAB SETTING
    store.chosenTab = store.sites[4].url


    const title = store.getProductTitle(idOfProd);
    const type = store.getProductType(idOfProd);
    
    const category = store.productCategories.find(cat =>cat.types.some(t => t.id === type)).name;

    const typeName = store.productCategories.find(cat => cat.name === category).types.find(t => t.id === type).name;


    const mainImage = store.getProductMainImage(idOfProd);
    const sideImage =  store.getProductSideImage(idOfProd);
    const properties = store.getProductProperties(idOfProd);
    const usage = store.getProductUsage(idOfProd);
    const text = store.getProductText(idOfProd);
    const noOfRefPics = store.getPruductReferencePics(idOfProd);


    //SET META TAG
    useHeaderSet()
</script>
<template>
    <div class="">
      <div class="middleMargin flex-column" :class="[{p15: store.screenSize==='mobile'},{w1300:store.screenSize==='desktop'},{w1000:['laptop','tabletL'].includes(store.screenSize)}]">
        <path-component class="middleMargin p-top-80" :path-items="['POLIOL',category,typeName]"/>
        <h1 class="smallTitle capital InterExtraBold">{{title}}</h1>
        <div class="grid twoColumns " :class="store.screenSize === 'mobile'? 'sinstore.getLocaleStringeColumn m-top-15 gap20':'m-top-80'">
          <div>
            <img :src="`/products/${mainImage}`" class="w80per" :alt="title">
          </div>
          <div class="leftText">
            <h2 class="xLargeText capital InterMedium" :class="store.screenSize === 'mobile'?'centerText':''">{{store.getLocaleString('pp1')}}</h2>
            <PoliolList :items="properties"/>
            <enquiry-button :text="store.getLocaleString('pp2')" class="m-top-40" @click="scrollToComponent('enquiry')" />
          </div>
        </div>
        <p class="largeText leftText m-top-80 line-height-1_4">{{text}}</p>
        <h4 class="xSmallTitle leftText m0 m-top-80">{{store.getLocaleString('pp3')}}</h4>
        <p class="leftText largeText w80per">{{usage}}</p>
        <img v-if="sideImage !== undefined" class="w80per middleMargin":src="`/products/${sideImage}`" :alt="title">
        <h4 v-if="noOfRefPics !== undefined" class="xSmallTitle leftText m0 m-top-80">{{store.getLocaleString('pp4')}}</h4>
        <PhotoGallery v-if="noOfRefPics !== undefined" :noOfSlides="noOfRefPics" :idOfProd="idOfProd"/>
      </div>
      <ContactUsPage
          title="Keressen minket!"
          subtitle="Forduljon hozzánk bizalommal"
          contact-email="tosi.janos@poliol.hu"
          contact-phone="06 20 342 2988"
          contact-topic="attachments"
          :attachment="title"
          class="m-bot-80"/>
      <FooterComp/>
    </div>
  </template>
